import { Button } from '@mui/material';
import { useAppKit } from '@reown/appkit/react';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { connectWalletButtonTranslation } from './translation';

export const ConnectWalletButton = () => {
  const { open: openConnectModal } = useAppKit();

  const { keys, t } = useTranslation(connectWalletButtonTranslation);

  return (
    <Button fullWidth onClick={() => openConnectModal()} size="large">
      {t(keys.connectWallet)}
    </Button>
  );
};
